import { useState } from 'react';
import clsx from 'clsx';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import TeamSeparatorIcon from 'ui/SVG/TeamSeparatorIcon';
import TriangleIcon from 'ui/SVG/TriangleIcon';
import TeamCard from '../TeamCard';
import data from '../data';
import { getBreakpoints, swiperChild, swiperMain } from './settings';

const teamName = Object.keys(data);

const SwiperDesktop: React.FC = (props) => {
  const [activeSlide, setActiveSlide] = useState<number>(0);

  const onSlideChange = (swiper: SwiperCore) => {
    setActiveSlide(swiper.realIndex);
  };

  return (
    <div className="team__slider">
      <button
        className={clsx('team__nav-btn team__nav-btn_prev', {
          active: activeSlide !== 0,
        })}
      >
        <TriangleIcon />
        <span>{teamName[activeSlide - 1] || <>&nbsp;</>}</span>
      </button>
      <Swiper
        {...swiperMain}
        onSlideChange={onSlideChange}
        className="team__swiper team__swiper_main"
      >
        {Object.values(data).map((item, itemId) => (
          <SwiperSlide className="team__slide team__slide_main" key={itemId}>
            <Swiper
              {...swiperChild}
              breakpoints={getBreakpoints(item.length)}
              className="team__swiper team__swiper_child"
            >
              {item.map((member) => (
                <SwiperSlide
                  className="team__slide team__slide_child"
                  key={member.id}
                >
                  <TeamSeparatorIcon className="team__separator" />
                  <TeamCard {...member} />
                </SwiperSlide>
              ))}
            </Swiper>
          </SwiperSlide>
        ))}
      </Swiper>
      <button
        className={clsx('team__nav-btn team__nav-btn_next', {
          active: activeSlide < teamName.length - 1,
        })}
      >
        <TriangleIcon />
        <span>{teamName[activeSlide + 1] || <>&nbsp;</>}</span>
      </button>
    </div>
  );
};

export default SwiperDesktop;
